import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useLocale } from '../../hooks/use-locale'
import moment from 'moment'

export default function OpenHome({ openHome, isAuction, propertyId }) {
  const locale = useLocale()

  return (
    <div className="c-openhome">
      <div className="c-openhome__date capitalize">
        {moment(openHome.start_date).format('dddd, MMMM Do YYYY')}
      </div>
      <div className="c-openhome__times">
        {moment(openHome.start_date).format('hh:mm a')}
        {openHome.end_date && (
          <>
            {' - '}
            {moment(openHome.end_date).format('hh:mm a')}
          </>
        )}
      </div>
      <div className="c-openhome__calendar">
        <a
          className="open-home-ical"
          target="_blank"
          href={
            isAuction
              ? `https://${process.env.GATSBY_WEBSITE_API_URL}/agencies/${process.env.GATSBY_AGENCY_ID}/invite/properties/${propertyId}/auction?locale=${locale}`
              : `https://${process.env.GATSBY_WEBSITE_API_URL}/agencies/${process.env.GATSBY_AGENCY_ID}/invite/properties/${propertyId}/open-homes/${openHome.id}?locale=${locale}`
          }
        >
          <i className="o-icon">
            <CalendarIconSvg />
          </i>
          <FormattedMessage id="open-homes.calendar" />
        </a>
      </div>
    </div>
  )
}

function CalendarIconSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g id="ico-calendar-white" fill="none" fillRule="evenodd">
        <path
          id="Rectangle"
          fill="#FFFFFF"
          fillRule="nonzero"
          d="M4,3 C3.44771525,3 3,3.44771525 3,4 L3,16 C3,16.5522847 3.44771525,17 4,17 L16,17 C16.5522847,17 17,16.5522847 17,16 L17,4 C17,3.44771525 16.5522847,3 16,3 L4,3 Z M4,2 L16,2 C17.1045695,2 18,2.8954305 18,4 L18,16 C18,17.1045695 17.1045695,18 16,18 L4,18 C2.8954305,18 2,17.1045695 2,16 L2,4 C2,2.8954305 2.8954305,2 4,2 Z"
        />
        <rect
          id="Rectangle-2"
          width="1"
          height="2"
          x="5"
          y="3"
          fill="#FFFFFF"
        />
        <rect
          id="Rectangle-3"
          width="16"
          height="1"
          x="2"
          y="7"
          fill="#FFFFFF"
        />
        <rect
          id="Rectangle-2"
          width="1"
          height="2"
          x="8"
          y="3"
          fill="#FFFFFF"
        />
        <rect
          id="Rectangle-2"
          width="1"
          height="2"
          x="11"
          y="3"
          fill="#FFFFFF"
        />
        <rect
          id="Rectangle-2"
          width="1"
          height="2"
          x="14"
          y="3"
          fill="#FFFFFF"
        />
        <polygon
          id="Path-2"
          fill="#FFFFFF"
          fillRule="nonzero"
          points="13.646 9.646 14.354 10.354 9 15.707 5.646 12.354 6.354 11.646 9 14.293"
        />
      </g>
    </svg>
  )
}
